<template>
    <div class="ah-page analysis-deposit-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>存款借款總覽</h1>
                        <el-select v-model="year" class="title-dropdown" @change="updateData">
                            <el-option v-for="item in yearList" :key="`year-${item}`" :value="item" :label="item"></el-option>
                        </el-select>
                    </div>
                    <div class="actions"></div>
                </div>

            </div>
        </div>
        <div class="ah-container" style="margin-top: 25px;">
            <DepositSummaryCard
                :year="year"
                :date="date"
                :isLoading="isLoading"
                :monthlyData="monthlyBankBalanceInfo"
                :taiwanDepositTotal="taiwanDepositTotal"
                :foreignDepositTotal="foreignDepositTotal"
                :taiwanLoanTotal="taiwanLoanTotal"
                :foreignLoanTotal="foreignLoanTotal"
                :cashTotal="cashTotal"
                :toBeCredited='toBeCredited'
            />
        </div>
        <div class="ah-container" style="margin-top: 25px;">
            <div class="ah-card shadow">
                <div class="title">{{ year }} 帳戶曲線圖</div>
                <DepositMonthlyChart :isLoading="isLoading" :data="monthlyBankBalanceInfo" :year="year" />
            </div>
        </div>
        <div class="ah-container" style="margin-bottom: 25px">
            <el-row :gutter="20" :type="winWidth > 768 ? 'flex' : ''" style="margin-bottom: 25px">
                <el-col :sm="12">
                    <DepositListCard :title="`台幣存款帳戶餘額`" :isLoading="isLoading" :list="taiwanNormalBanks" :showRat="false" :showEqualTwd="false" :date="date" />
                </el-col>
                <el-col :sm="12">
                    <DepositListCard :title="`外幣存款帳戶餘額`" :isLoading="isLoading" :list="foreignNormalBanks" totalPrefix="約當" :date="date" />
                </el-col>
            </el-row>
            <el-row :gutter="20" :type="winWidth > 768 ? 'flex' : ''">
                <el-col :sm="12">
                    <DepositListCard :title="`暫存台幣帳戶餘額`" :isLoading="isLoading" :list="taiwanTempBanks" :showRat="false" :showEqualTwd="false" :date="date" />
                </el-col>
                <el-col :sm="12">
                    <DepositListCard :title="`暫存外幣帳戶餘額`" :isLoading="isLoading" :list="foreignTempBanks" totalPrefix="約當" :date="date" />
                </el-col>
            </el-row>
        </div>
        <div class="ah-container" style="margin-bottom: 25px">
            <el-row :gutter="20" :type="winWidth > 768 ? 'flex' : ''">
                <el-col :sm="12">
                    <DepositListCard :title="`台幣借款餘額`" :isLoading="isLoading" :list="taiwanLoans" :showRat="false" :showEqualTwd="false" abs :date="date" />
                </el-col>
                <el-col :sm="12">
                    <DepositListCard :title="`外幣借款餘額`" :isLoading="isLoading" :list="foreignLoans" totalPrefix="約當" abs :date="date" />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import DepositMonthlyChart from './DepositMonthlyChart.vue';
import DepositSummaryCard from './DepositSummaryCard.vue';
import DepositListCard from './DepositListCard.vue';

export default {
    name: 'AnalysisDeposit',
    components: {
        DepositMonthlyChart,
        DepositSummaryCard,
        DepositListCard,
    },
    data() {
        return {
            year: new Date().getFullYear(),
            yearList: [],
            isLoading: false,
            monthlyBankBalanceInfo: null,
            foreignAccounts: [],
            taiwanAccounts: [],
            cash: null,
            toBeCredited: null,
            winWidth: window.innerWidth,
        };
    },
    computed: {
        taiwanBanks() {
            return this.taiwanAccounts.filter((x) => !x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        taiwanNormalBanks() {
            return this.taiwanAccounts.filter((x) => !x.isBorrower && x.typ === 0).sort((a, b) => b.bal - a.bal);
        },
        taiwanTempBanks() {
            return this.taiwanAccounts.filter((x) => !x.isBorrower && x.typ === 1).sort((a, b) => b.bal - a.bal);
        },
        foreignBanks() {
            return this.foreignAccounts.filter((x) => !x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        foreignNormalBanks() {
            return this.foreignAccounts.filter((x) => !x.isBorrower && x.typ === 0).sort((a, b) => b.bal - a.bal);
        },
        foreignTempBanks() {
            return this.foreignAccounts.filter((x) => !x.isBorrower && x.typ === 1).sort((a, b) => b.bal - a.bal);
        },
        taiwanLoans() {
            return this.taiwanAccounts.filter((x) => x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        foreignLoans() {
            return this.foreignAccounts.filter((x) => x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        taiwanDepositTotal() {
            const accounts = this.taiwanBanks.map((x) => x.bal);
            if (accounts.length === 0) return 0;
            return accounts.reduce((a, b) => a + b);
        },
        foreignDepositTotal() {
            const accounts = this.foreignBanks.map((x) => x.bal * x.rat);
            if (accounts.length === 0) return 0;
            return Math.round(accounts.reduce((a, b) => a + b));
        },
        taiwanLoanTotal() {
            const accounts = this.taiwanLoans.map((x) => x.bal);
            if (accounts.length === 0) return 0;
            return accounts.reduce((a, b) => a + b);
        },
        foreignLoanTotal() {
            const accounts = this.foreignLoans.map((x) => x.bal * x.rat);
            if (accounts.length === 0) return 0;
            return Math.round(accounts.reduce((a, b) => a + b));
        },
        loanTotal() {
            return this.taiwanLoanTotal + this.foreignLoanTotal;
        },
        cashTotal() {
            return this.cash;
        },
        todayDate() {
            return moment().format('YYYY-MM-DD');
        },
        date() {
            const now = new Date();
            if (this.year === now.getFullYear()) {
                return moment(now).format("YYYY-MM-DD");
            } else {
                return `${this.year}-12-31`;
            }
        },
    },
    mounted() {
        this.fetchYearOptions();

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        // 取得年份列表
        fetchYearOptions() {
            this.$api({
                url: 'FinancialAnalysisPage/GetDepositOverviewYearOptions',
                method: 'GET',
            }).then((resp) => {
                // 年份多的在前
                resp.data.options.sort((a, b) => b - a);

                this.status = 'success';

                if (resp.data.options && resp.data.options.length > 0) {
                    this.yearList = resp.data.options;
                } else {
                    this.yearList = [new Date().getFullYear()];
                }

                this.year = this.yearList[0];
                this.updateData();
            });
        },

        // 更新統計資料
        updateData() {
            this.isLoading = true;

            this.$api({
                url: `FinancialAnalysisPage/GetDepositOverview?Year=${this.year}`,
                method: 'GET',
            })
                .then((result) => {
                    console.log('GetDepositOverview', result.data);
                    this.monthlyBankBalanceInfo = result.data.monthlyBankBalanceInfo;
                    this.taiwanAccounts = result.data.taiwanAccounts;
                    this.foreignAccounts = result.data.foreignAccounts;
                    this.cash = result.data.cash;
                    this.toBeCredited = result.data.toBeCredited;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onResize() {
            this.winWidth = window.innerWidth;
        },
    },
};
</script>
<style lang="scss">
.analysis-deposit-page {
}
</style>
